import { render } from "./CheckboxField.vue?vue&type=template&id=84a186d8&scoped=true"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"

import "./CheckboxField.vue?vue&type=style&index=0&id=84a186d8&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a186d8"]])

export default __exports__